import { render } from "./SearchBoxRecentItems.vue?vue&type=template&id=4f93d6c3&scoped=true"
import script from "./SearchBoxRecentItems.vue?vue&type=script&lang=js"
export * from "./SearchBoxRecentItems.vue?vue&type=script&lang=js"

import "./SearchBoxRecentItems.vue?vue&type=style&index=0&id=4f93d6c3&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f93d6c3"]])

export default __exports__